<p-dialog [(visible)]="showModal" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
    styleClass="global-setup-dialog" header="Setup Required">

    <div class="flex flex-column align-items-center gap-4 p-4">
        <!-- Icon -->
        <i class="pi pi-exclamation-triangle text-6xl text-orange-500"></i>

        <!-- Title -->
        <h3 class="text-xl font-semibold text-center m-0 text-900">
            User Settings Required
        </h3>

        <!-- Message -->
        <p class="text-center text-600 m-0 line-height-3">
            Before you can use the application, you need to configure your user settings.
            This includes setting up your preferences, timezone, and other essential configurations.
        </p>

        <!-- Progress indicator while checking -->
        <div *ngIf="isChecking" class="flex align-items-center gap-2">
            <p-progressSpinner [style]="{'width': '20px', 'height': '20px'}" styleClass="custom-spinner">
            </p-progressSpinner>
            <span class="text-sm text-600">Checking settings...</span>
        </div>
    </div>

    <!-- Footer buttons -->
    <ng-template pTemplate="footer">
        <div class="flex justify-content-center gap-2 w-full">
            <p-button label="Configure Settings" icon="pi pi-cog" (onClick)="navigateToSettings()"
                [disabled]="isChecking" styleClass="p-button-primary">
            </p-button>
        </div>
    </ng-template>
</p-dialog>